export enum AdStatus {
    SCHEDULED = 'scheduled',
    ACTIVE = 'active',
    PAUSED = 'paused',
    FINISHED = 'finished'
}
